import React, { useEffect, useState } from 'react';
import { loadPanelService } from '../../../automaticPanel/panelsService';
import {
  GlobalDesignStyleGroup,
  StylesDerivedNativeActionNames,
} from '../../types';
import { Tooltip } from '@wix/design-system';
import { getTooltipMessage } from '../tooltips';
import { StylesDerivedNativeActions } from '@wix/editor-platform-host-integration-apis';
import { useTranslation } from '../../../useTranslation';
import { Host } from '@wix/sdk';

// TODO: remove this once we have the correct type from the panel service
type GroupPreviewType = 'border' | 'borderRadius' | 'boxShadow' | 'text';

const GROUP_PREVIEW_TYPE_BY_ACTION_NAME: Partial<
  Record<StylesDerivedNativeActionNames, GroupPreviewType>
> = {
  [StylesDerivedNativeActions.borderStyles]: 'border',
  [StylesDerivedNativeActions.cornerStyles]: 'borderRadius',
  [StylesDerivedNativeActions.shadowStyles]: 'boxShadow',
  [StylesDerivedNativeActions.textStyles]: 'text',
};

export const useGroupsPreviewPS = (
  actionName: StylesDerivedNativeActionNames,
  group: GlobalDesignStyleGroup,
) => {
  const [GroupPreviewComponent, setGroupPreviewComponent] = useState<
    any | null
  >(null);
  const [host, setHost] = useState<Host | null>(null);
  const [t] = useTranslation();

  useEffect(() => {
    (async () => {
      const hostInstance = await group.createHost();
      setHost(hostInstance);
    })();
  }, [group]);

  useEffect(() => {
    const loadGroupComponent = async () => {
      if (!host) {
        return;
      }

      const panelService = await loadPanelService(host);

      if (GROUP_PREVIEW_TYPE_BY_ACTION_NAME[actionName]) {
        const groupPreviewType = GROUP_PREVIEW_TYPE_BY_ACTION_NAME[actionName];

        if (!groupPreviewType) {
          setGroupPreviewComponent(null);
          return;
        }

        setGroupPreviewComponent(
          () =>
            panelService.getGroupPreview({
              previewType: groupPreviewType,
            }).Component,
        );
      }
    };

    loadGroupComponent();
  }, [host, actionName]);

  return (groupPreviewProps: any) => {
    if (!GroupPreviewComponent) {
      return null;
    }

    return (
      <Tooltip
        enterDelay={500}
        content={getTooltipMessage(t, actionName, group)}
      >
        <GroupPreviewComponent {...groupPreviewProps} />
      </Tooltip>
    );
  };
};
